import { jsx as _jsx } from "react/jsx-runtime";
import { useNavigate } from 'react-router';
import { useQuery } from '../../hooks';
import { ejectToken, loadAuth } from '../../api';
export const AccessGate = () => {
    const { param: token } = useQuery('token');
    const { param: redirect } = useQuery('redirect');
    const nav = useNavigate();
    const targetPath = redirect || '/';
    const existingToken = ejectToken();
    if (existingToken) {
        nav(targetPath);
        return _jsx("div", {});
    }
    if (token) {
        loadAuth({ token });
        window.location.href = targetPath;
    }
    else {
        nav('/login');
    }
    return _jsx("div", {});
};
